import { render, staticRenderFns } from "./CoinStoreReturnWallet.vue?vue&type=template&id=3d1c8744&scoped=true&"
import script from "./CoinStoreReturnWallet.vue?vue&type=script&lang=ts&"
export * from "./CoinStoreReturnWallet.vue?vue&type=script&lang=ts&"
import style0 from "./CoinStoreReturnWallet.vue?vue&type=style&index=0&id=3d1c8744&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d1c8744",
  null
  
)

export default component.exports